import React, { FC } from "react";
import { Card, Col, Divider, Row } from "antd";
import moment from "moment";
import { EyeOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";

import useHttpGet from "../../../hooks/useHttpGet";
import { IResultResponse } from "../../../models/response/result.model";
import { INews } from "../../../models/news.model";
import { APIRoutes } from "../../../http";

const ViewNews: FC = () => {
  const { id } = useParams();

  const { fetchedData, loading } = useHttpGet<IResultResponse<INews>>(
    `${APIRoutes.NEWS}/${id}`,
    {
      defaultValue: { result: {} as INews },
    }
  );

  return (
    <Row justify="center" align="top">
      <Col xs={24} sm={24} md={20}>
        <Card
          className="mb-1 custom-card-1"
          title={
            <div className="d-flex align-items-center">
              <span className="fs-36">{fetchedData.result?.title}</span>
            </div>
          }
          actions={[
            <span>{moment(fetchedData.result?.createdOn).format("LLLL")}</span>,
            <span>
              <EyeOutlined /> {fetchedData.result?.watchCount}
            </span>,
          ]}
          loading={loading}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: fetchedData.result?.content,
            }}
            className="pt-0_5"
          />
          <Divider />
          <div className="w-100 d-flex justify-content-end align-items-center">
            <span className="mr-0_5">Source:</span>
            <a
              target="_blank"
              rel="noreferrer"
              href={fetchedData?.result?.sourseUrl}
              className="mt-0_5 mb-0_5"
            >
              {fetchedData?.result?.sourseUrl}
            </a>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default ViewNews;
